import {
  Button,
  Divider,
  InputBase,
  InputAdornment,
  IconButton,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorOutline, Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate, useNavigation } from "react-router-dom";
import axios from "axios";
import SigninWithGoogle from "./SigninWithGoogle";
import FlowModal from "../modals/FlowModal";
import posthog from "posthog-js";
import Front from "@frontapp/plugin-sdk";

const Login = () => {
  const navigate = useNavigate();
  const [openFlowModal, setOpenFlowModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [user, setUser] = useState({
    email: "",
    password: "",
    login_from_google: false
  });
  const[remember_me, setRememberMe] = useState(true)
  const [err_msg, setErrorMsg] = useState(null);
  const [loader, setLoader] = useState(false)
  const [isFrontPlugin, setIsFrontPlugin] = useState(false);
  const [frontUserEmail, setFrontUserEmail] = useState(null);

  useEffect(()=> {
   if(JSON.parse(localStorage.getItem('user')) && JSON.parse(localStorage.getItem('organization'))){
    navigate('/dashboard')
   }
   if( JSON.parse(localStorage.getItem('user'))  && !JSON.parse(localStorage.getItem('organization'))){
    navigate('/create-organization')
   }
  },[])

  useEffect(() => {
    // Check if we're running as a Front plugin and subscribe to updates
    const checkFrontPlugin = async () => {
      try {
        // Subscribe to context updates
        const subscribe = Front.contextUpdates.subscribe((context) => {
          //('Front context received:', context);
          
          if (context && context.teammate && context.teammate.email) {
            setIsFrontPlugin(true);
            setFrontUserEmail(context.teammate.email);
            //console.log('Front email set to:', context.teammate.email);
          } else {
            setIsFrontPlugin(false);
            setFrontUserEmail(null);
            //console.log('No Front user found in context');
          }
        });

        // Cleanup subscription on unmount
        return () => {
          subscribe.unsubscribe();
        };
      } catch (error) {
        //console.log('Not running as Front plugin:', error);
        setIsFrontPlugin(false);
        setFrontUserEmail(null);
      }
    };
    
    checkFrontPlugin();
  }, []);

  const login = async () => {
    setErrorMsg(null);
    setLoader(true);

    // Check Front email if running as plugin
    if (isFrontPlugin && frontUserEmail) {
      //console.log('Comparing emails:', {
      //  frontEmail: frontUserEmail,
      //  loginEmail: user.email
      //});
      
      if (user.email.toLowerCase() !== frontUserEmail.toLowerCase()) {
        setErrorMsg(`Your login email must match your Front email address (${frontUserEmail})`);
        setLoader(false);
        return;
      }
    }

    try {
        let user_data = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "get-user",
          user
        )

      let org_id = user_data.data.user.relatedOrgs.L[0]?.M.org_id.S || null
      localStorage.setItem('user', JSON.stringify(user_data.data.user) )

      if(org_id){
        let org = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "get-organization",
          { orgId: org_id }
        );
  
        localStorage.setItem('organization', JSON.stringify(org.data.organization) )
  
        navigate("/dashboard/");
      }else{
         navigate('/create-organization')
      }

      setLoader(false);
    } catch (error) {
      console.log(error)
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrorMsg(error.response.data.message)
      }
      setLoader(false)
    }
  };

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  return (
    <div>
      <FlowModal open={openFlowModal} setOpen={setOpenFlowModal}/>
      <div className="grid lg:grid-cols-4">
        <div className="col-span-1 lg:pt-[80px] pt-[80px] bg-white min-h-[100vh] px-8  lg:my-0">
          <div className="flex items-center justify-center">
            <img src="/icons/login_img.png" className="w-[50px]" />
          </div>
          <div className="text-center lg:text-[16px] mt-4  font-semibold ">
            Log in
          </div>

          {err_msg && (
            <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
              <ErrorOutline sx={{ fontSize: "" }} /> {err_msg}
            </div>
          )}

          <div className="flex items-center justify-center py-2 rounded-[4px] mt-4">
          <SigninWithGoogle page='login' user={user} 
                setErrormsg={setErrorMsg} navigate={navigate} 
                 loader={loader} setLoader={setLoader}/>
          </div>

          <div className="flex items-center justify-center space-x-1 mb-4 mt-1  ">
            <Divider className="w-[100px]" />
            <div className="relative bottom-[2px]">or</div>
            <Divider className="w-[100px]" />
          </div>

          <div className="space-y-2 mb-3">
            <div className=" lg:text-[14px] text-[13px] ">Email Address</div>
            <InputBase
            value={user.email}
            onChange={(e)=>{
              setUser({...user, email:e.target.value})
            }}
              sx={{
                bgcolor: "#F7F7F8",
                width: "100%",
                px: 2,
                py: "2px",
                fontSize: "14px",
              }}
            />
          </div>

          <div className="space-y-2">
            <div className=" lg:text-[14px] text-[13px] ">Password</div>
            <InputBase
              type={showPassword ? "text" : "password"}
              value={user.password}
            onChange={(e)=>{
              setUser({...user, password:e.target.value})
            }}
              endAdornment={
                <InputAdornment
                  position="end"
                  onClick={handleTogglePassword}
                  className="cursor-pointer"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </InputAdornment>
              }
              sx={{
                bgcolor: "#F7F7F8",
                width: "100%",
                px: 2,
                py: "2px",
                fontSize: "14px",
              }}
            />
          </div>

          <div className="flex items-center justify-between mt-2">
            <div className="flex items-center">
              <Checkbox
                
                value={remember_me}
                onChange={(e)=> {
                 if(e.target.checked){
                  setRememberMe(false)
                   }else{
                    setRememberMe(true)
                   }
                }}
                size="lg"
                sx={{
                  color: "#605BFF",
                  "&.Mui-checked": {
                    color: "#605BFF", // Set color for checked state
                  },
                }}
              />
              <div className="text-[13px]">Remember me</div>
            </div>

            <div
              className="text-[#605BFF] lg:text-[13px] text-[12px] hover:underline cursor-pointer "
              onClick={() => {
                navigate("/forgot-password");

              }}
            >
              Forgot Password ?
            </div>
          </div>

          <div className="flex justify-center pt-6 pb-4 space-x-2">
            <Button
              sx={{
                textTransform: "none",
                bgcolor: "#605BFF",
                color: "white",
                py: "6px",
                px: "40px",
                borderRadius: "7px",
                fontSize: { lg: "14px", xs: "13px" },
                width: "100%",
              }}
              onClick={login}
            >
               {loader? (
                          <CircularProgress
                            size={"1.3rem"}
                            sx={{ color: "white" }}
                          />
                        ) : (
                          " Login"
                        )}
            </Button>
          </div>

          <div className="text-black text-center lg:text-[13px] text-[12px] ">
            Don't have account yet?{" "}
            <span
              className="text-[#605BFF] hover:underline cursor-pointer "
              onClick={() => navigate("/register")}
            >
              {" "}
              New Account
            </span>
          </div>
        </div>

        <div className="col-span-3 lg:flex justify-center my-auto hidden ">
          <img
            src="/icons/illustration.png"
            className=" w-[580px] h-[500px] "
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
